import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Container from 'kepler/lib/components/Container';
import Button from 'kepler/lib/components/Button';
import { triggerBack, triggerLink } from '../lib/marketplace';
import BackButton from './BackButton';
import AppDetailContentTop from './AppDetailContentTop';
import AppDetailContentPoints from './AppDetailContentPoints';
import AppDetailContentTopVideo from './AppDetailContentTopVideo';
import AppDetailContentDescription from './AppDetailContentDescription';
import getContent from '../lib/dictionaryFetcher';
import Marketplaces from '../../lib/singletons/marketplaces';

const AppDetailContent = props => {
  const { partner, app, experimentation } = props;
  const marketplaces = Marketplaces.instance();

  const getStarted = getContent(
      'merchanthub',
      `apps.${partner}.getStarted`,
      ''
    ),
    showBackButton = get(app, 'type', '') === 'BUSINESS',
    textBack = getContent('merchanthub', 'back', ''),
    isDesktop = get(app, 'deviceInfo.isDesktop', true);

  const handleTriggerBack = () => {
    triggerBack(props);
  };

  const triggerLinkTop = () => {
    triggerLink('top', props);
  };

  const triggerLinkBottom = () => {
    triggerLink('bottom', props);
  };

  const sharedProps = {
    partner,
    isDesktop
  };

  const renderTopContent = () => {
    const sharedTopContentProps = {
        ...sharedProps,
        onClick: triggerLinkTop
      },
      marketplace = marketplaces[partner] || {},
      videoLink = marketplace.videoLink;
    return videoLink ? (
      <AppDetailContentTopVideo
        {...sharedTopContentProps}
        videoLink={videoLink}
      />
    ) : (
      <AppDetailContentTop {...sharedTopContentProps} />
    );
  };

  return (
    <Container className="merchanthub-apps">
      {showBackButton && (
        <BackButton text={textBack} triggerBack={handleTriggerBack} />
      )}

      {renderTopContent()}

      <AppDetailContentDescription {...sharedProps} />

      <AppDetailContentPoints
        {...sharedProps}
        experimentation={experimentation}
      />

      <div className="marketplace-bottom-button">
        <Button onClick={triggerLinkBottom} className="get-started-button">
          {getStarted}
        </Button>
      </div>
    </Container>
  );
};

AppDetailContent.propTypes = {
  partner: PropTypes.string,
  app: PropTypes.object,
  experimentation: PropTypes.object
};

export default AppDetailContent;
